import React from 'react';
import { useTranslation } from 'react-i18next';

import imgURL from '../../assets/images/404.svg'

import './NotFound.scss';

/**
 * 404 page
 * 
 * @component - NotFound
 * @parentComponent - App
 */

export default function NotFound() {

    const { t } = useTranslation();

    return (
        <div className="NotFound fadeIn">
            <img src={imgURL} alt="not-found-img"/>
            <h1>404</h1>
            <h2>{t('Страницата не беше намерена.')}</h2>
        </div>
    )
}
